export var ADD_BOOTH = "ADD_BOOTH";
export var EDIT_BOOTH = "EDIT_BOOTH";
export var CLOSE_BOOTH = "CLOSE_BOOTH";
export var FETCH_LINK_RESOURCE = "FETCH_LINK_RESOURCE";
export var FETCH_INTERACTIVE_MAPS = "FETCH_INTERACTIVE_MAPS";
export var ADD_BOOTH_LINK = "ADD_BOOTH_LINK";
export var UPDATE_BOOTH_COLOR = "UPDATE_BOOTH_COLOR";
export var DELETE_BOOTH_LINK = "DELETE_BOOTH_LINK";
export var OPEN_IMAP = "OPEN_IMAP";
export var ADD_IMAP_NAME = "ADD_MAP_NAME";
export var OPEN_IMAP_MODAL = "OPEN_IMAP_MODAL";
export var CHANGE_MAP_IMAGE = "CHANGE_MAP_IMAGE";
export var MAP_IMAGE_CHANGED = "MAP_IMAGE_CHANGED";
export var DEFAULT_IMAP_VALUE = {
  interactivemapid: "",
  eventid: "",
  mapname: "",
  mapfilepath: "",
  thumbfilepath: "",
};
export var UPDATE_IMAP_UPLOAD_PROGRESS = "UPDATE_IMAP_UPLOAD_PROGRESS";
export var IMAP_IMAGE_UPLOADED = "IMAP_IMAGE_UPLOADED";
export var IMAP_IMAGE_UPLOAD_FAILED = "IMAP_IMAGE_UPLOAD_FAILED";
export var IMAP_IMAGE_TO_UPLOAD = "IMAP_IMAGE_TO_UPLOAD";
export var ADD_BOOTH_DATA = "ADD_BOOTH_DATA";
export var EDIT_BOOTH_DATA = "EDIT_BOOTH_DATA";
export var SHOW_BOOTH_EDITOR = "SHOW_BOOTH_EDITOR";
export var SHOW_ADD_BOOTH_INFO = "SHOW_ADD_BOOTH_INFO";
export var INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID =
  "INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID";
